import { takeLatest, put } from 'redux-saga/effects'
import * as CONST from './const'
import * as ERRORS from 'Reducers/Errors/const'
import { apiClient } from 'Module/API/Client'
import NProgress from 'nprogress'
import { callApi } from '../apiCall'

/**
 * Get  pickup times by city id
 *
 * @param {Object} action
 */
function* getPickupTimes(action) {
  NProgress.start()
  const response = yield callApi(apiClient.getPickupTimes, action.cityId)
  const body = yield response.json()

  try {
    if (response.ok) {
      yield put({
        type: CONST.GET_PICKUP_TIMES_BY_CITY_ID_SUCCESS,
        payload: {
          pickupTimesList: body,
        },
      })
    } else {
      yield put({
        type: ERRORS.PUSH_API_ERROR,
        error: body,
      })
    }
  } catch (ex) {}

  NProgress.done()
}

/**
 * Save  pickup times list
 *
 * @param {Object} action
 */
function* savePickupTimesList(action) {
  NProgress.start()
  const { cityId, formData } = action.payload
  const response = yield callApi(apiClient.savePickupTimes, cityId, formData)
  const body = yield response.json()

  try {
    if (response.ok) {
      yield put({
        type: CONST.SAVE_PICKUP_TIMES_LIST_SUCCESS,
        payload: {
          pickupTimesList: body,
        },
      })
    } else {
      yield put({
        type: ERRORS.PUSH_API_ERROR,
        error: body,
      })
    }
  } catch (ex) {}

  NProgress.done()
}

/**
 * Watch pickup times by city id
 */
export function* watchGetPickupTimes() {
  yield takeLatest(CONST.GET_PICKUP_TIMES_BY_CITY_ID, getPickupTimes)
}

/**
 * Watch save pickup times list
 */
export function* watchSavePickupTimesList() {
  yield takeLatest(CONST.SAVE_PICKUP_TIMES_LIST, savePickupTimesList)
}



// WEBPACK FOOTER //
// ./src/Reducers/PickupTimes/sagas.js